import React, { PureComponent } from "react"
import { Container, Row, Col, Spinner, Modal, Button, Form } from "react-bootstrap"
import { Subscription } from "rxjs"
import GeneralInformation, { PersonDemographicRecord, PersonDemographicObject, RegMode } from "../../../api/OrderResults/OrderResultModel/GeneralInformation"
import { GeneralInformationGet, GetPersonDemographicsDetail } from "../../../api/OrderResults/GeneralInformationGet"
import { toast } from "react-toastify"
import { AppState } from "../../../AppState"
import FormatSSN from "../../../formatters/FormatSSN"
import FormatDate from "../../../formatters/FormatDate"
import 'react-datepicker/dist/react-datepicker.css'
import FormatError from "../../../formatters/FormatError"
import ActionButton from "../../ActionButton"
import { MergeEmployees } from "../../../api/OrderResults/SearchEmployesToMerge"
import RegulatoryMode from "../../../api/LabService/LabServiceModel/RegulatoryMode"
import LabServiceRegulatoryModesGetObservable from "../../../api/LabService/LabServiceRegulatoryModesGet"

type CreateRegModeString = {
  EmpCat: string
  EmployeeCategoryID: number
  PersonRegModeEmpCatID: number
  Primary: boolean
  RegMode: string
  RegulatoryModeID: number
}

function regulatoryModeValue(results: CreateRegModeString[]): string {
  if (results.length > 0) {
    let primary: CreateRegModeString | undefined = results.find(item => item.Primary)
    let result: string = primary ? primary.RegMode : ""
    let otherRegModes: string = results.filter(item => !item.Primary).map(item => item.RegMode).join(", ")
    if (otherRegModes !== "") {
      result = `${result} (${otherRegModes})`
    }
    return result
  } else {
    return "N/P"
  }
}

const HeaderRow = (props: { title: string }) =>
  <Row>
    <Col><h5 className="pt-3 pb-2">{props.title}</h5></Col>
  </Row>



const InfoRow = (props: { title: string, value: string | null, className?: string }) => <Row className="py-1">
  <Col xs={8} md={6}><span className="caption">{props.title}</span></Col>
  <Col xs={8} md={6}><span className={props.className}>{props.value}</span></Col>
</Row>



interface EmployeeToMergeInfoProps {
  OriginalPersonID: number
  MergePersonID: number
  isGov?: boolean
  onHide: () => void
}



interface EmployeeToMergeInfoState {
  data?: GeneralInformation,
  saving: boolean
  loading: boolean
  isRegulatoryModesLoading: boolean
  isRegulatoryModesLoaded: boolean
  regulatoryModes: RegulatoryMode[]


}
export default class EmployeeToMergeInfo extends PureComponent<EmployeeToMergeInfoProps, EmployeeToMergeInfoState> {
  state: EmployeeToMergeInfoState = {
    data: undefined,
    saving: false,
    loading: false,
    isRegulatoryModesLoading: false,
    isRegulatoryModesLoaded: false,
    regulatoryModes: []
  }
  loadSubscription?: Subscription
  saveSubscription?: Subscription
  regulatoryModesSubscription?: Subscription

  componentDidMount() {
    this.loadGeneralInfo(this.props.MergePersonID)
    this.loadRegulatoryModes()
  }

  componentWillUnmount() {
    this.loadSubscription && this.loadSubscription.unsubscribe()
    this.saveSubscription && this.saveSubscription?.unsubscribe()
    this.regulatoryModesSubscription && this.regulatoryModesSubscription.unsubscribe()
  }



  loadGeneralInfo(PersonID: number) {
    this.setState({ loading: true })
    this.loadSubscription && this.loadSubscription.unsubscribe()
    this.loadSubscription = GeneralInformationGet(PersonID).subscribe(
      (data: GeneralInformation) => this.setState({ data: data }),
      (error) => {
        this.setState({ loading: false })
        toast.error(FormatError(error))
      },
      () => this.setState({ loading: false })
    )
  }
  loadRegulatoryModes = () => {

    if (this.state.isRegulatoryModesLoaded) {
      return
    }
    this.setState({ isRegulatoryModesLoading: true, regulatoryModes: [] })
    this.regulatoryModesSubscription && this.regulatoryModesSubscription.unsubscribe()
    this.regulatoryModesSubscription = LabServiceRegulatoryModesGetObservable(true).subscribe(
      (data: RegulatoryMode[]) => this.setState({
        regulatoryModes: data,
        isRegulatoryModesLoading: false,
        isRegulatoryModesLoaded: true
      }),
      () => this.setState({ isRegulatoryModesLoading: false })
    )
  }
  handleSubmit = () => {
    const originalPersonId = this.props.OriginalPersonID
    const mergePersonID = this.props.MergePersonID
    this.setState({ saving: true })
    this.saveSubscription && this.saveSubscription?.unsubscribe()
    this.saveSubscription = MergeEmployees(originalPersonId, mergePersonID, 0, 0).subscribe(
      ((result) => {
        this.setState({ saving: false })
        toast.success("Merged personnel data successfully.")
        this.props.onHide()
      }),
      (error) => {
        this.setState({ saving: false })
        toast.error(FormatError(error))
      }
    )
    return false
  }

  createDonorIdTypeRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="Company ID Type" value={data.CompanyPrimaryID} className="text-uppercase" />

  }
  createDonorIdRow = () => {
    const data: GeneralInformation = this.state.data!
    const idType = data.PrimaryIDType
    let val = data.PrimaryIDValue
    if (data.CompanyPrimaryID === "SSN") {
      if (data.SSN) {
        val = data.SSN
      }
      val = FormatSSN(val)
    }
    return <InfoRow title="Donor ID" value={val} className="text-uppercase" />

  }

  createFirstNameRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="First Name" value={data.FirstName} className="text-uppercase" />
  }


  createLastNameRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="Last Name" value={data.LastName} className="text-uppercase" />

  }


  createCompanyRow = (name: string) => {
    return <InfoRow title="COMPANY" value={name} />
  }

  createLocationRow = (name: string) => {
    return <InfoRow title="LOCATION" value={name} />
  }

  createEmployerIdRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="EMPLOYER ID" value={data.Employer} className="text-uppercase" />

  }

  createAlternateIdRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="ALTERNATE ID" value={data.Alternate} className="text-uppercase" />
  }



  createSSNRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="SSN" value={FormatSSN(data.SSN || "")} />
  }


  createDriverIdRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="DRIVER ID" value={data.Driver} className="text-uppercase" />
  }

  createGenderRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="GENDER" value={`${data.Gender === "F" ? "Female" : ""}${data.Gender === "M" ? "Male" : ""}`} />
  }

  createDateOfBirthRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="DATE OF BIRTH" value={FormatDate(data.DOB || "")} />
  }

  createHireDateRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="HIRE DATE" value={FormatDate(data.HireDate || "")} />
  }

  createTerminationDateRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="TERMINATION DATE" value={FormatDate(data.TerminationDate) || "N/P"} />
  }

  createInactiveRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="ACTIVE" value={!data.Inactive ? "Yes" : "No"} />
  }

  createRegulatoryModeRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="REGULATORY MODE" value={regulatoryModeValue(data.RegModCatList)} className="primary" />
  }

  createInfoRows = () => {
    const data: GeneralInformation = this.state.data!
    const donorIdTypeRow = this.createDonorIdTypeRow()
    const donorIdRow = this.createDonorIdRow()
    const firstNameRow = this.createFirstNameRow()
    const lastNameRow = this.createLastNameRow()
    const companyRow = this.createCompanyRow(data.Company)
    const locationRow = this.createLocationRow(data.Location)
    const employerIdRow = this.createEmployerIdRow();
    const driverIdRow = this.createDriverIdRow()
    const ssnRow = this.createSSNRow()
    const alternateIdRow = this.createAlternateIdRow()
    const genderRow = this.createGenderRow()
    const dateOfBirthRow = this.createDateOfBirthRow()
    const hireDateRow = this.createHireDateRow()
    const terminationDateRow = this.createTerminationDateRow()
    const activeRow = this.createInactiveRow()
    const regulatoryModeRow = this.createRegulatoryModeRow()


    const result = {
      donorIdTypeRow: donorIdTypeRow,
      donorIdRow: donorIdRow,
      firstNameRow: firstNameRow,
      lastNameRow: lastNameRow,
      companyRow: companyRow,
      locationRow: locationRow,
      employerIdRow: employerIdRow,
      driverIdRow: driverIdRow,
      ssnRow: ssnRow,
      alternateIdRow: alternateIdRow,
      genderRow: genderRow,
      dateOfBirthRow: dateOfBirthRow,
      hireDateRow: hireDateRow,
      terminationDateRow: terminationDateRow,
      activeRow: activeRow,
      regulatoryModeRow: regulatoryModeRow,

    }
    return result
  }



  render() {
    const { loading, saving } = this.state
    if (!this.state.data) {
      return this.state.loading ? <Spinner animation="border" size="sm" /> : <></>
    }

    const infoRows = this.createInfoRows();


    return (
      <Modal backdrop="static" show={true} onHide={this.props.onHide} size="xl" dialogClassName="dark">
        <Modal.Header closeButton={true}>
          <Modal.Title>MERGE DONOR</Modal.Title>
        </Modal.Header>
        <Modal.Body className="event-details">
          <Container className="general-info px-4 pb-4 pt-3">
            <Row>
              <Col xs={12} lg={6}>
                <HeaderRow title="DONOR INFO" />
              </Col>
              <Col xs={12} lg={6}>
                <HeaderRow title="" />
              </Col>
            </Row>
            <Row>
              <Col xs={12} lg={6}>
                {infoRows.companyRow}
                {infoRows.donorIdTypeRow}
                {infoRows.firstNameRow}
                {infoRows.employerIdRow}
                {infoRows.ssnRow}
                {infoRows.genderRow}
                {infoRows.hireDateRow}
                {infoRows.activeRow}
              </Col>
              <Col xs={12} lg={6}>
                {infoRows.locationRow}
                {infoRows.donorIdRow}
                {infoRows.lastNameRow}
                {infoRows.driverIdRow}
                {infoRows.alternateIdRow}
                {infoRows.dateOfBirthRow}
                {infoRows.terminationDateRow}
                {infoRows.regulatoryModeRow}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        {<Modal.Footer>
          {<ActionButton variant="primary"
            disabled={loading || saving}
            onClick={this.handleSubmit}
            spin={saving}>Merge</ActionButton>}
          {<ActionButton variant="primary"
            disabled={loading || saving}
            onClick={this.props.onHide}>Cancel</ActionButton>}
        </Modal.Footer>}
      </Modal>
    )
  }

}

